import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export function userAdmin () {
  return {
    namespaced: true,
    state: {
      token: null,
      storeCode: null,
      storeId: null,
      userType: 'seller',
      userStoreId: null,
      current: null,
      addresses: [],
      coupons: [],
      addressSelected: undefined,
      role: null,
      isOnlineMode: false,
      ip: '0.0.0.0'
    },
    getters,
    actions,
    mutations
  }
}
